module.exports = __webpack_public_path__ + "static/media/rundkolben_antwort2.7467efce.jpg";